export const CONSTRUCTION_NAMES: Record<string, string> = {
  outpost: 'Előőrs', mining_station: 'Bányaállomás', energy_station: 'Energiaállomás', logistics_hub: 'Elosztóközpont',
  station_upgrade: 'Állomás fejlesztése', lab_build: 'Kutatólabor építése', lab_upgrade: 'Kutatólabor fejlesztése',
  'ship:scout': 'Kutatóhajó', 'ship:construction': 'Építőhajó', 'ship:corvette': 'Korvett', 'ship:frigate': 'Fregatt', 'ship:cruiser': 'Cirkáló',
};

export function constructionName(kind: string): string { return CONSTRUCTION_NAMES[kind] ?? 'Építés'; }
